<template>
	<div class="main-container">
		<div
			v-bind:style="{ height: '100px', 'background-color': '#fff' }"
		></div>
		<HeaderComponent
            :text="showingCabinList ? $t('text.select_cabin') : $t('text.select_dates')"
            backgroundColor="#fff"
        />
		<Transition appear name="fade">
			<div>
				<div class="center-container">
					<HotelDatePicker
						class="date-picker"
						:alwaysVisible="false"
						showWeekNumbers
						:firstDayOfWeek="1"
						:showYear="true"
						:i18n="localeStrings" 
						:startingDateValue="start_date"
						:endingDateValue="end_date"
						:hoveringTooltip="false"
						@check-in-changed="setStartDate($event)"
						@check-out-changed="setEndDate($event)"
					/>
					<div v-if="is_loading" class="loader-container" style="text-align: center; margin-top:80px;">
						<b-spinner
							variant="dark"
							label="Spinning"
							class="login-loader"
						></b-spinner>
					</div>
					<div v-if="showingCabinList" class="cabin-list-container">
						<div 
							v-for="cabin in availableCabins" :key="cabin.cabin_number" 
							@click="rowPressed(cabin)"
						>	
							<div v-if="cabin.expanded" class="cabin-row cabin-row-expanded">
								<div class="cabin-row-left-item">
									<b>{{ $t(cabin.getNameKey()) }}</b> <br> 
									{{ $t(cabin.getShortDescriptionKey()) }} <br>
									<span style="color: #20c997;">
										{{nrOfNights}} {{ nrOfNights > 1 ? $t('text.nights') : $t('text.night') }}, {{cabin.price}} {{ $t( 'text.sek' )}}
									</span><br>
								</div>
								<div class="cabin-row-right-item">
									<b-icon class="chevron-icon" icon="chevron-up" font-scale="1"></b-icon>
								</div>
								<div class="cabin-row-right-item">
									<b-button @click="goToBooking(cabin)" variant="primary" class="book-button">
										{{ $t('text.book') }}
									</b-button>
								</div>
								<br>
								<p class="cabin-description">
									{{ $t(cabin.getExpandedDescriptionKey()) }}<span v-if="cabin.cabin_number!=0"><br>{{ $t('text.located_at') }} <a href="http://maps.google.com/?q=Hjortronvägen 15, 780 91 Sälen" target="_blank">Hjortronvägen 15</a>.</span>
								</p>
								<a  
									v-if="cabin.cabin_number!=0"
									:href="cabin.getInfoRouterLink() + '?cabin=' + cabin.cabin_number + '&start_date=' + start_date.toISOString() + '&end_date=' + end_date.toISOString()"
								>
									{{ $t('text.more_info_and_pictures') }}
								</a>
							</div>
							<div v-else class="cabin-row">
								<div class="cabin-row-left-item">
									<b>{{ $t(cabin.getNameKey()) }}</b> <br> 
									{{ $t(cabin.getShortDescriptionKey()) }} <br>
									<span style="color: #20c997;">
										{{nrOfNights}} {{ nrOfNights > 1 ? $t('text.nights') : $t('text.night') }}, {{cabin.price}} {{ $t( 'text.sek' )}}
									</span><br>
								</div>
								<div class="cabin-row-right-item">
									<b-icon class="chevron-icon" icon="chevron-down" font-scale="1"></b-icon>
								</div>
								<div class="cabin-row-right-item">
									<b-button @click="goToBooking(cabin)" variant="primary" class="book-button">
										{{ $t('text.book') }}
									</b-button>
								</div>
							</div>
						</div>
						<div 
							v-for="cabin in unavailableCabins" :key="cabin.cabin_number" 
							@click="rowPressed(cabin)"
						>
							<div class="cabin-row">
								<div class="cabin-row-left-item">
									<b>{{ $t(cabin.getNameKey()) }}</b> <br> 
									{{ $t(cabin.getShortDescriptionKey()) }} <br>
									<span class="disabled-text">{{ $t('text.not_available_singular') }}</span><br>
								</div>
								<div class="cabin-row-right-item">
									<br>
									<span class="disabled-text">{{ $t('text.not_available_singular') }}</span>
									<br>
								</div>
							</div>
						</div>
					</div>
				</div>
				
			</div>
		</Transition>
	</div>
</template>

<script>

import HotelDatePicker from "vue-hotel-datepicker2";
import "vue-hotel-datepicker2/dist/vueHotelDatepicker2.css";

import HeaderComponent from "../components/HeaderComponent.vue";
import CabinApiService from "../../services/cabin_api_service";
import AvailableCabin from '../../models/available_cabin';

export default {
	name: "CheckAvailabilityListPage",
	components: {
		HotelDatePicker,
		HeaderComponent,
	},
	data() {
		return {
			start_date: null,
			end_date: null,
			available_cabins: [],
			is_loading: false,
			locale_se: {
				"night": "Natt",
				"nights": "Nätter",
				"week": "vecka",
				"weeks": "veckor",
				"day-names": ["Mån", "Tis", "Ons", "Tor", "Fre", "Lör", "Sön"],
				"check-in": "Check-in",
				"check-out": "Check-out",
				"month-names": [
					"Januari",
					"Februari",
					"Mars",
					"April",
					"Maj",
					"Juni",
					"Juli",
					"Augusti",
					"September",
					"Oktober",
					"November",
					"December",
				],
				"tooltip": {
					"halfDayCheckIn": "Tillgänglig CheckIn",
					"halfDayCheckOut": "Tillgänglig CheckOut",
					"saturdayToSaturday": "Endast Lördag till Söndag",
					"sundayToSunday": "Endast Söndag till Söndag",
					"minimumRequiredPeriod": "%{minNightInPeriod} %{night} minimum.",
				},
			},
			locale_en: {
				"night": "Night",
				"nights": "Nights",
				"week": "week",
				"weeks": "weeks",
				"day-names": ["Mon", "Tue", "Wed", "Thur", "Fri", "Sat", "Sun"],
				"check-in": "Check-in",
				"check-out": "Check-out",
				"month-names": [
					"January",
					"February",
					"March",
					"April",
					"May",
					"June",
					"July",
					"August",
					"September",
					"October",
					"November",
					"December",
				],
				"tooltip": {
					"halfDayCheckIn": "Available CheckIn",
					"halfDayCheckOut": "Available CheckOut",
					"saturdayToSaturday": "Only Saturday to Saturday",
					"sundayToSunday": "Only Sunday to Sunday",
					"minimumRequiredPeriod": "%{minNightInPeriod} %{night} minimum.",
				},
			}
		}
	},
	computed: {
		localeStrings() {
			return (this.$root.$i18n.locale == "en" ? this.locale_en : this.locale_se);
		},
		showingCabinList() {
			return this.start_date && this.end_date && this.available_cabins.length > 0 && !this.is_loading
		},
		availableCabins() {
			return this.available_cabins.filter((cabin) => {
				return cabin.available
			});
		},
		unavailableCabins() {
			return this.available_cabins.filter((cabin) => {
				return !cabin.available
			});
		},
		nrOfNights() {
			if (this.start_date && this.end_date) {
				return Math.round(
					(this.end_date - this.start_date) / (1000 * 3600 * 24)
				);
			} else {
				return 0;
			}
		}
	},
	methods: {
		setStartDate(date) {
            this.price = 0;
            if (date != null) {
                date.setHours(12,0,0,0);
            }
            this.start_date = date;
        },
        setEndDate(date) {
            if (date != null) {
                date.setHours(12,0,0,0);
            }
            this.end_date = date;

            if (this.start_date != null && this.end_date != null) {
                this.fetchAvailableCabins()
            }
        },
		async fetchAvailableCabins() {
            if (this.start_date === this.end_date) {
                return;
            }
            this.is_loading = true;
            try {
                const params = 'start_date=' + this.start_date.toISOString() + '&end_date=' + this.end_date.toISOString()
                const data = await CabinApiService.get_available_cabins(params);
                this.available_cabins = data.data['cabins'].map(dict => {
                    return new AvailableCabin(dict);
                });
                this.is_loading = false;
            } catch (error) {
                localStorage.clear();
                this.is_loading = false;
            }
        },
		rowPressed(cabin) {
			cabin.expanded = !cabin.expanded;
		},
        goToBooking(cabin) {
            if (cabin.available) {
                this.$router.push({ path: '/book', query: { 
                    cabin: cabin.cabin_number, 
                    start_date: this.start_date.toISOString(), 
                    end_date: this.end_date.toISOString() 
                }});
            }
        },
	},
	created() {
        var start_date = this.$route.query.start_date;
        var end_date = this.$route.query.end_date;
		if (start_date != null) {
            start_date = new Date(start_date);
            if (start_date != null) {
                this.setStartDate(start_date);
                this.form_set_from_query = true;
            }
        }
        if (end_date != null) {
            end_date = new Date(end_date);
            if (end_date != null) {
                this.setEndDate(end_date);
                this.form_set_from_query = true;
            }
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main-container {
	height: 100%;
	width: 100%;
	background-color: #fff;
	text-align: center;
	overflow: visible;
}

.center-container {
	background-color: #fff;
	height: 100%;
	width: 100%;
	max-width: 1000px;
	margin:auto;
	text-align: left;
	box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.1);
	padding:30px;
	margin-top: -20px;
}

.cabin-list-container {
	padding-top: 30px;
}

.date-picker {
    height:52px;
    border-width: 1px;
    border-color: #000;
    border-style: solid;
    font-weight: bold;
}

.cabin-row {
    cursor: pointer;
    padding: 15px;
	border-width: 0px 0px 1px 0px;
    border-style: solid;
    border-color: #eee;
}

.cabin-row-expanded {
	padding-bottom:30px;
}

.cabin-description {
	margin-top: 20px;
	margin-bottom: 20px;
}

.cabin-row:hover {
    background-color: #fafafa;
}

.cabin-row-left-item {
    display:inline-block;
}

.cabin-row-right-item {
    display:inline-block;
    float:right;
}

.cabin-row-disabled {
    border-width: 1px 0px 0px 0px;
    border-style: solid;
    border-color: #eee;
    background-color: #eee;
    padding: 15px;
}

.disabled-text {
	color: #aaa;
}

.book-button {
	margin:20px;
	margin-right:30px;
}

.book-button:hover {
	color: #4da3ff;
}

.chevron-icon {
	margin-top:33px;
}

.fade-short-enter-active, .fade-short-leave-active {
	transition: opacity 1s;
}

.fade-short-enter, .fade-short-leave-to {
	opacity: 0;
}

.fade-long-enter-active, .fade-long-leave-active {
	transition: opacity 3s;
}

.fade-long-enter, .fade-long-leave-to {
	opacity: 0;
}
</style>
